

// get a color ranging from none to green based on index
export const getRatingColor = (value: number | undefined, isWhiteBackground?: boolean) => {
  if (!value) value = 0;

  const r = isWhiteBackground ? 44 : 54;
  const g = isWhiteBackground ? 255 : 184;
  const b = isWhiteBackground ? 44 : 54;

  const alpha = (value / 10) * (isWhiteBackground ? 0.9 : 0.8);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};


// get a color ranging from red to green based on index
export const getIndexColor = (index: number | undefined, lightness?: number, alpha?: number) => {
  if (index === undefined || index === null) return '#00000000';

  const startHue = 0; // red
  const endHue = 120; // green

  lightness = lightness ?? 50;
  const alphaToUse = alpha ?? 1;

  const hue = startHue + ((endHue - startHue) * (index / 10));

  const color = `hsla(${hue}, 100%, ${lightness}%, ${alphaToUse})`;

  return color;
};


// get color blind rating colot -> all colors are shades of blue that apparently could be slightly distinguishable for color blind people
export const getColorBlindRatingColor = (value: number, opacity: number) => {
  if (!value) value = 0;

  const baseBlue = 200;
  const maxBlue = 25;

  const blueComponent = baseBlue - (value / 10) * (baseBlue - maxBlue);

  const alpha = (value / 10) * opacity;

  return `rgba(${blueComponent}, ${blueComponent}, 255, ${alpha})`;
};
